import { useFetch } from "src/hooks/useFetch";
import { SearchResultsService } from "src/services";
import { GlobalTaskSearchResult } from "src/types";

export default function useGetGlobalTasksSearchResults() {
  const [
    globalTasksSearchResultsState,
    fetchGlobalTasksSearchResults,
    abortGlobalTasksSearchResultsFetch,
  ] = useFetch<GlobalTaskSearchResult[]>();

  const handleFetchGlobalTasksSearchResults = (
    wsWorkspaceUuid: string,
    globalTaskUuids?: string[],
  ) => {
    fetchGlobalTasksSearchResults((signal) =>
      SearchResultsService.getGlobalTasks(
        wsWorkspaceUuid,
        globalTaskUuids,
        signal,
      ),
    );
  };

  const initializeGlobalTasksSearchResultsFetch = (
    wsWorkspaceUuid: string,
    globalTaskUuids?: string[],
  ) => {
    abortGlobalTasksSearchResultsFetch();
    handleFetchGlobalTasksSearchResults(wsWorkspaceUuid, globalTaskUuids);
  };

  return [
    globalTasksSearchResultsState,
    initializeGlobalTasksSearchResultsFetch,
  ] as const;
}
